import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxLoadingModule } from 'ngx-loading';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { SharedModule } from '../../template/shared/shared.module';
import { MatRadioModule } from '@angular/material/radio';
import { CustomerContectListingComponent } from './customer-contect-listing/customer-contect-listing.component';
import { AddCustoemrContectLoginComponent } from './customer-contect-listing/add-custoemr-contect-login/add-custoemr-contect-login.component';
import { CustomerContectService } from './customer-contect.service';
import { NgScrollbarModule } from 'ngx-scrollbar';

export const routes: Routes = [{
  path: '',
  children: [
      {
          path: '',
          pathMatch: 'full',
          redirectTo: 'customer-contact-login'
      },
     { path: 'customer-contact-login', component: CustomerContectListingComponent,  data: { breadcrumb: 'Customer Contact Login' } },
     { path: 'customer-contact-login/create', component: AddCustoemrContectLoginComponent,  data: { breadcrumb: 'Add Customer Contact Login' } },
     { path: 'customer-contact-login/edit/:id', component: AddCustoemrContectLoginComponent, data: { breadcrumb: 'Edit Customer Contact Login' } },
  ]
}];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NgxDatatableModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    SharedModule,
    NgScrollbarModule,
    NgxLoadingModule.forRoot({}),
    SweetAlert2Module.forRoot(),
  ],
  declarations: [CustomerContectListingComponent, AddCustoemrContectLoginComponent],
  
  providers: [
    CustomerContectService
  ]
})
export class CustomerContectModule { }
